import React from 'react';
import { reduxForm, Field } from 'redux-form';
import FormField from '../../forms/FormField';
import { Button } from 'react-bootstrap';

const PasswordResetForm = props => {
  const { handleSubmit, submitting, message } = props;
  return (
    <form onSubmit={handleSubmit}>
      <p>
        Enter your email address associated with your account.
        <br />
        You will recieve an email with directions to reset your password.
      </p>
      {message && <div className="login-error">{message}</div>}
      <Field
        required
        name="email"
        type="text"
        component={FormField.Input}
        placeholder="Email"
        validate={[value => value ? undefined : 'Required']}
      />
      <Button bsStyle="primary" type="submit" disabled={submitting}>
        Reset Password
      </Button>
    </form>
  );
};

export default reduxForm({
  form: 'password-reset',
  touchOnBlur: false // call validation only on submit
})(PasswordResetForm);



// WEBPACK FOOTER //
// ./src/components/routes/clientPasswordReset/PasswordRequestForm.js